import { GlobalRole } from './models';

/**
 * L'area `/admin`: SUPERADMIN e SYSTEM (quest'ultimo in sola lettura lato
 * API). Unica definizione per guard di rotta, login, sidebar e contesto del
 * ruolo: prima il predicato era ricopiato a mano in ognuno.
 */
export function isAdminOrSystemRole(
  role: GlobalRole | null | undefined
): boolean {
  return role === GlobalRole.SUPERADMIN || role === GlobalRole.SYSTEM;
}
